export const krzysztofJaniszewski = {
    'firstName': 'Krzysztof',
    'lastName': 'Janiszewski',
    'mydrId': null,
    'profession': 'Autor',
    'avatar': 'krzysztof-janiszewski.webp',
    'slug': 'autor-krzysztof-janiszewski',
    'locations': [],
    'services': []
}